import { render, staticRenderFns } from "./Masterfile.vue?vue&type=template&id=0e4f6e7c&scoped=true&"
import script from "./Masterfile.vue?vue&type=script&lang=js&"
export * from "./Masterfile.vue?vue&type=script&lang=js&"
import style0 from "./Masterfile.vue?vue&type=style&index=0&id=0e4f6e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4f6e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
